import { useEffect } from 'react';
import servicePerformance from './service-performance-observer';

export const useFCPMarker = () => {
  // Enable Performance Observer measurements and cleanup
  useEffect(() => {
    // Mark First Contentful Paint Point in the Performance Timeline
    servicePerformance.setFirstContentfulPaintMark();
  }, []);
};

export const useLCPMarker = () => {
  // Enable Performance Observer measurements and cleanup
  useEffect(() => {
    // Mark First Contentful Paint Point in the Performance Timeline
    servicePerformance.setLargestContentfulPaintMark();
  }, []);
};

export const useTTIMarker = (condition: boolean = true) => {
  // Enable Performance Observer measurements and cleanup
  useEffect(() => {
    // Mark First Contentful Paint Point in the Performance Timeline
    if (condition) {
      servicePerformance.setTimeToInteractiveMark();
    }
  }, [condition]);
};

export const useMCPMarker = (pageName: string, condition: boolean = true) => {
  // Mark Critical Content Loaded in the Performance Timeline
  useEffect(() => {
    if (condition) {
      servicePerformance.setFirstMeaningfulPaintMark(pageName);
    }
  }, [condition, pageName]);
};
